import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-left: -14px;
  margin-bottom: 15px;
  @media (max-width: 650px) {
    margin-left: 0px;
  }
`

export const GenreButton = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  transition-duration: 0.2s;
  padding: 0px 24px;
  color: #000;
  position: relative;
  margin-bottom: 50px;
  cursor: pointer;
  @media (max-width: 650px) {
    padding: 0px;
    width: 33%;
  }
  .iconContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    border-radius: 25px;
    transition-duration: 0.2s;
  }
  .icon {
    width: 25px;
    height: 20px;
  }
  .title {
    position: absolute;
    margin-top: 10px;
    letter-spacing: 0px;
    font-size: 14px;
    line-height: 22px;
    bottom: -30px;
  }
  &:hover {
    transform: scale(1.1);
  }
`
